import { zodResolver } from '@hookform/resolvers/zod';
import type { PropsWithChildren } from '@shared/utils';
import { FormProvider, useForm } from 'react-hook-form';

import { QConfigEditFormSchema, type QConfigEditFormInput } from './qconfig-edit-form-schema';

interface QConfigEditFormProviderProps extends PropsWithChildren {
  qConfigName: string;
  totalQuestions: number;
}

export default function QConfigEditFormProvider(props: Readonly<QConfigEditFormProviderProps>) {
  const { children, qConfigName, totalQuestions } = props;

  const formContext = useForm<QConfigEditFormInput>({
    defaultValues: {
      qConfigName,
      totalQuestions,
    },
    resolver: zodResolver(QConfigEditFormSchema),
  });

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
